import { render, staticRenderFns } from "./ContractsRecord.vue?vue&type=template&id=89fc2a76"
import script from "./ContractsRecord.vue?vue&type=script&lang=js"
export * from "./ContractsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports